import React from "react"

const MailChimpForm = ({ submitText }) => {
  return (
    <div id="mc_embed_signup">
      <form
        action="//com2com.us15.list-manage.com/subscribe/post?u=c8843765eb009b80380fa43e5&amp;id=2528084813"
        className="validate"
        id="mc-embedded-subscribe-form"
        method="post"
        name="mc-embedded-subscribe-form"
        novalidate=""
        target="_blank"
      >
        <div id="mc_embed_signup_scroll">
          <div className="mc-field-group">
            <input
              className="required email form-control"
              id="mce-EMAIL"
              name="EMAIL"
              placeholder="Your email address"
              type="email"
            />
          </div>
          <div className="clear" id="mce-responses">
            <div
              className="response"
              id="mce-error-response"
              style={{ display: "none" }}
            >
              &nbsp;
            </div>
            <div
              className="response"
              id="mce-success-response"
              style={{ display: "none" }}
            >
              &nbsp;
            </div>
          </div>
          {/* real people should not fill this in and expect good things - do not remove this or risk form bot signups */}
          <div
            aria-hidden="true"
            style={{ position: "absolute", left: "-5000px" }}
          >
            <input
              name="b_c8843765eb009b80380fa43e5_90af3626e8"
              tabindex="-1"
              value=""
              type="text"
            />
          </div>
          <div className="mt-4 text-center">
            <input
              className="button inverse btn btn-primary rounded-pill mb-0"
              id="mc-embedded-subscribe"
              name="subscribe"
              value={submitText}
              type="submit"
            />
          </div>
        </div>
      </form>
    </div>
  )
}

export default MailChimpForm
